import styled from '@emotion/styled';
import { ListItemSecondaryText } from '$components/List';

import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const ExportStatusTitle = styled(ListItemSecondaryText)`
  margin-top: ${spacing.xSmall};
  color: ${({ isFailed }) => (isFailed ? COLORS.red : '')};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  :hover {
    text-decoration: ${({ onClick }) => (onClick ? 'underline' : '')};
  }
`;

export const ModalContent = styled.div`
  padding: ${spacing.xLarge};

  & > div {
    margin-bottom: ${spacing.small};
  }
`;
